<template>
    <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">
        <NavbarDark/>

        <div class="page-title" :class="{ 'ltr': $i18n.locale === 'en', 'rtl': $i18n.locale === 'ar' }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('Privacy Policy')}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <section>
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-md-12">
                        <div class="story-wrap explore-content">
                            <div class="story-wrap explore-content" v-html="currentPrivacyData"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <FooterTop :bg="'theme-bg'"/>
        <FooterDark/>
        <ScrollToTop/>
    </div>

</template>

<script setup>
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';

import { computed } from 'vue';
import { privacyEn } from '@/data/data';
import { privacyAr } from '@/data/data';
import { useI18n } from "vue-i18n";   
const { locale } = useI18n();

const currentPrivacyData = computed(() => {
    return locale.value === 'ar' ?  privacyAr[0] : privacyEn[0];
});

//SEO 
import { useHead } from '@vueuse/head'
import { useRoute } from 'vue-router'
const route = useRoute()
const baseUrl = 'https://ruqm.me'

const canonicalUrl = computed(() =>
  `${baseUrl}${route.path}`
)

const supportedLocales = ['en', 'ar']

const hreflangLinks = computed(() => {
  const pathWithoutLang = route.path.replace(/^\/(en|ar)/, '')

  return supportedLocales.map(lang => ({
    rel: 'alternate',
    hreflang: lang,
    href: `${baseUrl}/${lang}${pathWithoutLang}`
  }))
})
useHead(() => ({
  link: [
    { rel: 'canonical', href: canonicalUrl.value },
    ...hreflangLinks.value,
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}/en${route.path.replace(/^\/(en|ar)/, '')}`
    }
  ]
}))
</script>
